import { createDefaultTyrann } from '@apis/common';
import { preAlertLogPages, preAlertLog } from '@models/PreAlertLog';
import * as t from 'io-ts';

export const preAlertLogApis = createDefaultTyrann({
  '/pre-alert-log/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      query: t.type({
        page: t.number,
      }),
      response: {
        200: preAlertLogPages,
      },
    },
  },
  '/pre-alert-log/{id}/latest/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.array(preAlertLog),
      },
    },
  },
  '/dashboard/pre-alert-log/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      query: t.type({
        page: t.number,
      }),
      response: {
        200: preAlertLogPages,
      },
    },
  },
  '/dashboard/pre-alert-log/{id}/latest/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.array(preAlertLog),
      },
    },
  },
});
